module.exports = {
    WS: 'WS',
    WS2: 'WS2',
    XML: 'XML',
    CSV: 'CSV',
}